import React, { useRef, useState } from 'react';
import './ClippedTooltip.scss';

const ClippedTooltip = ({ text, className }: { text: string, className: string }) => {
    const spanRef = useRef<HTMLSpanElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    return (
        <div
            className={`ClippedTooltip-wrapper ${className}`}
            onMouseEnter={() => {
                if (spanRef.current === null) return;
                if (spanRef.current.scrollWidth !== spanRef.current.clientWidth) {
                    setShowTooltip(true);
                }
            }}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <span ref={spanRef} className='ClippedTooltip-text'>
                {text}
            </span>
            {showTooltip && (
                <div className={`ClippedTooltip-tooltip ${className}`}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default ClippedTooltip;
